// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__21DD8","title":"Images90_title__1FOt5","images":"Images90_images__2cASK"};